export default __webpack_public_path__ + "static/japanese-5-a2929f41507152d13903a2f64a4b4ed6.png";